import { Tables } from "database.types";
import { Plus } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { addToWatchlist, removeFromWatchlist } from "@/api/watchlist";
import { CardVariantWithBinder } from "@/types/varinats";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateBinderWatchlistVariantsQueries } from "@/queries/common";

export interface Props {
  variant: CardVariantWithBinder;
  scanning?: boolean;
}

export function CardVariantItemWatchlist({ variant, scanning = false }: Props) {
  const [isInWatchlistOptimistic, setIsInWatchlistOptimistic] = useState(
    !!variant.watchlist,
  );

  const queryClient = useQueryClient();

  const onClick = useCallback(async () => {
    if (isInWatchlistOptimistic) {
      setIsInWatchlistOptimistic(false);
      await removeFromWatchlist(variant.id);
    } else {
      setIsInWatchlistOptimistic(true);
      await addToWatchlist(variant.id, scanning);
    }
    invalidateBinderWatchlistVariantsQueries();
  }, [isInWatchlistOptimistic, scanning, variant.id]);

  useEffect(() => {
    setIsInWatchlistOptimistic(!!variant.watchlist);
  }, [variant.watchlist]);

  if (isInWatchlistOptimistic) {
    return (
      <Button size="sm" variant="destructive" onClick={onClick}>
        <Plus className="w-4 h-4" />
        Remove from Watchlist
      </Button>
    );
  }

  return (
    <Button size="sm" variant="outline" onClick={onClick}>
      <Plus className="w-4 h-4" />
      Add to Watchlist
    </Button>
  );
}
